'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckBox = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(CheckBox, _React$PureComponent);

    function CheckBox() {
        (0, _classCallCheck3.default)(this, CheckBox);
        return (0, _possibleConstructorReturn3.default)(this, (CheckBox.__proto__ || (0, _getPrototypeOf2.default)(CheckBox)).apply(this, arguments));
    }

    (0, _createClass3.default)(CheckBox, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                text = _props.text,
                className = _props.className,
                inputProps = (0, _objectWithoutProperties3.default)(_props, ['name', 'text', 'className']);

            var inputClass = (className || '') + ' form-control';

            return _react2.default.createElement(
                'div',
                { className: 'form__checkbox' },
                _react2.default.createElement('input', (0, _extends3.default)({ id: name, name: name, className: inputClass, type: 'checkbox' }, inputProps)),
                _react2.default.createElement('label', { htmlFor: name, style: { opacity: 1 }, dangerouslySetInnerHTML: { __html: text } })
            );
        }
    }]);
    return CheckBox;
}(_react2.default.PureComponent), _class.propTypes = {
    name: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired,
    checked: _propTypes2.default.bool.isRequired,
    onChange: _propTypes2.default.func.isRequired
}, _temp);
exports.default = CheckBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/CheckBox.js
// module id = 566
// module chunks = 0 2